import React from 'react';
import PropTypes from 'prop-types';
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import Icon from '@material-ui/core/Icon';

const mainButtonStyles = {
  // opacity: 0.5,
}

const actionButtonStyles = {
  // opacity: 0.5,
}

class FabGuide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clickComponent: null
    }
  }

  setComponent = func => {
    const comp = func();
    this.setState({clickComponent: comp});
  }

  createAction = (item, index) => (
    <Action
      key={`action-${index}`}
      text={item.text}
      onClick={() => this.setComponent(item.onClick)}
      style={actionButtonStyles}
    >
      {
        item.icon &&
        <Icon>{item.icon}</Icon>
      }
    </Action>
  )

  render() {
    const { icon, event, actions } = this.props;
    const { clickComponent } = this.state;
    return (
      <React.Fragment>
        <Fab
          mainButtonStyles={mainButtonStyles}
          icon={<Icon>{icon}</Icon>}
          event={event}
          >
          {actions.map((item, index) => this.createAction(item, index))}
        </Fab>
        {clickComponent}
      </React.Fragment>
    )
  }
}

FabGuide.propTypes = {
  icon: PropTypes.string,
  actions: PropTypes.array,
  event: PropTypes.string,
};

FabGuide.defaultProps = {
  icon: 'live_help',
  actions: [],
  event: 'click',
};

export default FabGuide;
